import React, {useEffect, useState} from 'react'
import { Timeline } from 'antd'
import styles from './index.module.less'
import _lodash from 'lodash'
import {statusChineseConversion, approvalResultFunc} from '../utils'
const ApprovalInformation = () => {
  const [detailsData, setdetailsData] = useState(JSON.parse(sessionStorage.getItem('detailsData')))
  console.log(detailsData)
  useEffect(() => {
    setdetailsData(JSON.parse(sessionStorage.getItem('detailsData')))
  }, [])
  return (
    <div style={{ border: '1px solid #d9d9d9' }}>
      <div className={styles.public_info}>
        <section className={styles.publicsection} style={{fontWeight: '900', fontSize: '16px'}}>
          <span className={styles.publlictitle}><span className={styles.required}></span>商品名称：</span>
          <span className={styles.public_span_style}>{detailsData ? detailsData.item_info.item_name || '--' : '--'}</span>
        </section>

        <section className={styles.publicsection} style={{fontWeight: '900', fontSize: '16px', marginTop: '18px'}}>
          <span className={styles.publlictitle}><span className={styles.required}></span>商品编码：</span>
          <span className={styles.public_span_style}>{detailsData ? detailsData.item_info.item_code || '-- ' : '--'}</span>
        </section>

        <section className={styles.publicsection} style={{paddingLeft: '62px'}}>
          <Timeline>
            {detailsData && detailsData.checks.length !== 0
              ? detailsData.checks.map((item, index) => (
                <Timeline.Item style={{paddingBottom: '160px'}} key={index}>
                  <div>  <span>{item.approval_part === 'first' ? '初审阶段' : '复审阶段'}</span></div>
                  <div><span>审核状态：</span><span className={styles.public_span_style}>{statusChineseConversion(item.status)}</span></div>
                </Timeline.Item>

              )) : null
            }
          </Timeline>
        </section>
        <section className={styles.publicsection} style={{paddingLeft: '91px'}}>
          {detailsData && detailsData.checks.length !== 0
            ? detailsData.checks.map((item, index) => (
              <span style={{display: 'block', marginBottom: '154px'}} key={index}>
                <div>审核结果：<span>{approvalResultFunc(item.approval_result)}</span></div>
                <div>审核意见：<span>{item.speech || '--'}</span></div>
              </span>

            )) : null}
        </section>
      </div>
    </div>
  )
}
export default ApprovalInformation



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/newproductdetails/approval-information.js